import { Post } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const PostToGreenroomSocket = <T = unknown>({
  channel,
  type,
  message,
}: {
  channel: string;
  type: string;
  message: T;
}) => {
  return Post({
    host: GREENROOM_HOST,
    path: '/v2/greenroom/platform-to-greenroom-socket',
    includeGreenroomToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    body: { channel, type, message },
  });
};

export default PostToGreenroomSocket;
